import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { TweenLite } from "gsap";

@Component({
  moduleId: 'module.id',
  selector: 'cb-progress',
  styles: [require('./cb-progress.component.scss')],
  template: require('./cb-progress.component.html')
})
export class CbProgressComponent implements AfterViewInit {
  @Input()
  public progress: number;

  constructor() {

  }

  public ngAfterViewInit() {
    
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/cb-progress/cb-progress.component.ts